export var GuidedPhotoCapture;
(function (GuidedPhotoCapture) {
    GuidedPhotoCapture["TASK_STATUS_OPENED"] = "OPENED";
    GuidedPhotoCapture["TASK_STATUS_INVALID"] = "INVALID";
    GuidedPhotoCapture["TASK_STATUS_CLOSED"] = "CLOSED";
})(GuidedPhotoCapture || (GuidedPhotoCapture = {}));
//# sourceMappingURL=GuidedPhotoCapture.js.map